import { Component, OnInit } from '@angular/core';

import { CHANNELS_ENUMERATION, CHANNELS_EVENTS_ENUMERATION, MarketingEventService } from '@shared/services';

@Component({
  selector: 'app-not-found',
  template: '',
})
export class NotFoundComponent implements OnInit {
  constructor(private readonly marketingEventService: MarketingEventService) {}

  ngOnInit(): void {
    this.marketingEventService.notifyEventToChannel(CHANNELS_ENUMERATION.CLOSE_CHANNEL, {
      event: CHANNELS_EVENTS_ENUMERATION.HOME,
    });
  }
}
